module.exports = __webpack_public_path__ + "static/email-e415da4f058274aabe019ea733a58869.png";